// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"X","red":"Y","calloutlink":"Z","headerTopBanner":"_","bgcolorRed":"aa","headerTopCallout":"ba","searchBanner":"ca","hideMobile":"da"};